import React, { useState, useEffect } from "react";

const Clock = () => {
  const deg = 6;
  const [day, setDay] = useState(new Date());
  const [hours, setHours] = useState();
  const [minutes, setMinutes] = useState();
  const [seconds, setSeconds] = useState(new Date().getSeconds() * deg);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDay(new Date());
      setHours(day.getHours() * 30);
      setMinutes(day.getMinutes() * deg);
      setSeconds(day.getSeconds() * deg);
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [day]);

  return (
    <>
      <div className="clock">
        <div
          style={{ transform: `rotateZ(${hours + minutes / 12}deg)` }}
          className="hour"
        ></div>
        <div
          style={{ transform: `rotateZ(${minutes}deg)` }}
          className="min"
        ></div>
        <div
          style={{ transform: `rotateZ(${seconds}deg)` }}
          className="sec"
        ></div>
      </div>
    </>
  );
};
export default Clock;
